import { Button, Dialog } from '@mui/material';
import BackButton from '@mui/icons-material/ArrowBackOutlined';
import { ThemeProvider } from '@mui/styles';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { BlueButton } from '../components/BlueButton';
import { DefaultButton } from '../components/DefaultButton';
import { Participant } from '../components/Participant';
import { GetUser } from '../services/Session';
import '../styles/style.css';
import theme from '../styles/theme';
import { FillParticipant } from './FillParticipant';

class TransactionAddTicket extends Component {
  constructor(props) {
    super(props);
    const user = GetUser();
    this.state = {
      tickets: [
        {
          name: user.name ? user.name : '',
          email: user.email ? user.email : '',
          phone: user.phone ? user.phone : '',
          gender: user.gender ? user.gender : '',
          student_id_number: user.nip ? user.nip : '',
        },
      ],
      showModal: false,
      onEdit: false,
      indexEdit: 0,
      loading: false,
    };
  }

  emptyParticipant = () => {
    return {
      name: null,
      email: null,
      phone: null,
      gender: null,
      student_id_number: null,
    };
  };

  onEdit = (index) => {
    this.setState({
      showModal: true,
      onEdit: true,
      indexEdit: index,
    });
  };

  onEditFinished = (participant) => {
    let newTickets = [...this.state.tickets];
    newTickets[this.state.indexEdit] = participant;
    this.setState({ tickets: newTickets, showModal: false });
  };

  onAdd = () => {
    this.setState({
      showModal: true,
      onEdit: false,
    });
  };

  onAddFinished = (participant) => {
    let newTickets = [...this.state.tickets];
    newTickets.push(participant);
    this.setState({ tickets: newTickets, showModal: false });
  };

  onDelete = (index) => {
    let newTickets = [...this.state.tickets];
    if (index !== -1) {
      newTickets.splice(index, 1);
      this.setState({ tickets: newTickets });
    }
  };

  handleOpen = () => {
    this.setState({ showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  handleLanjutkan = () => {
    const { product_id, product_name, unit_price } = this.props.location.state;

    this.props.history.push({
      pathname: '/konfirmasi-pesanan',
      state: {
        product_id: product_id,
        product_name: product_name,
        quantity: this.state.tickets.length,
        tickets: this.state.tickets,
        unit_price: unit_price,
        total: this.state.tickets.length * unit_price,
      },
    });
  };

  render() {
    const { product_name, unit_price } = this.props.location.state;
    return (
      <ThemeProvider theme={theme}>
        <div className="header">
          <Button
            startIcon={<BackButton />}
            style={{
              position: 'absolute',
              height: 60,
              width: 60,
              top: 0,
              left: 0,
            }}
            onClick={() => {
              this.props.history.goBack();
            }}
          />
          <div className="center">
            <h3 className="title">{product_name}</h3>
          </div>
        </div>
        <div className="wrapper" ref={(el) => (this.container = el)}>
          {
            <Dialog
              fullWidth
              maxWidth="xl"
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={this.state.showModal}
              onClose={this.handleClose}
            >
              <FillParticipant
                participant={this.state.onEdit ? this.state.tickets[this.state.indexEdit] : this.emptyParticipant()}
                onSaved={this.state.onEdit ? this.onEditFinished : this.onAddFinished}
              />
            </Dialog>
          }
          {this.state.tickets.map((participant, index) => (
            <Participant
              key={`${index}#${participant.name}`}
              data={{
                name: participant.name,
                gender: participant.gender,
                phone: participant.phone,
                email: participant.email,
                student_id_number: participant.student_id_number,
              }}
              onEdit={() => {
                this.onEdit(index);
              }}
              onDelete={() => {
                this.onDelete(index);
              }}
            />
          ))}
          <DefaultButton
            style={{ marginTop: 20 }}
            onClick={() => {
              this.onAdd();
            }}
            text="Tambah"
          />
          <div style={{ paddingBottom: 100 }}></div>
        </div>
        <div className="footer" style={{ height: 90, fontFamily: 'Roboto' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              marginTop: 5,
            }}
          >
            <div style={{ alignSelf: 'center' }}>{`Subtotal : ${'\u00a0'}`}</div>
            <div style={{ color: '#00bfe6', fontSize: 18 }}>{this.state.tickets.length} x</div>
            <div style={{ color: '#00bfe6', fontSize: 18 }}>
              {`${'\u00a0'}Rp`}
              <NumberFormat value={unit_price} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />
            </div>
            <div style={{ color: '#00bfe6', fontSize: 18 }}>{`${'\u00a0'}=`}</div>
            <div style={{ color: '#00bfe6', fontSize: 18 }}>
              {`${'\u00a0'}Rp`}
              <NumberFormat
                value={this.state.tickets.length * unit_price}
                displayType={'text'}
                thousandSeparator={'.'}
                decimalSeparator={','}
              />
            </div>
          </div>
          <BlueButton
            disabled={this.state.showModal || this.state.loading}
            loading={this.state.loading}
            onClick={() => {
              this.handleLanjutkan();
            }}
            text="Lanjutkan"
          />
        </div>
      </ThemeProvider>
    );
  }
}

export default TransactionAddTicket;
